window.UpdatePremiumBankForm = (function () {
    window.dataLayer = window.dataLayer || [];
    let self = {
        elements: {
            UpdateForm: '#update-bank-form',
            messages: {
                invalidAccountNumber: '#update-bank-acc-no-error',
                invalidSortNumber: '#update-bank-sort-no-error',
                questionOneErrorMessage: '#update-bank-questionOneErrorMessage',
                questionTwoErrorMessage: '#update-bank-questionTwoErrorMessage',
                questionOneEmptyErrorMessage: '#update-bank-questionOneEmptyErrorMessage',
                questionTwoEmptyErrorMessage: '#update-bank-questionTwoEmptyErrorMessage',
            },
            textBox: {
                bankAccountName: '#update-bank-acc-name',
                bankSortNumber: '#update-bank-sort-no',
                bankAccountNumber: '#update-bank-acc-no',
                hiddenAccountNameErrorMessage: '#accountNameErrorMessage',
                hiddenEnablePhcDirectDebit: '#enablePhcDirectDebitValue',
            },
            button: {
                saveDetails: '#update-bank-save',
            },
            radio:{
                questionOneYesRadio: '#update-bank-questionOneYesRadio',
                questionOneNoRadio: '#update-bank-questionOneNoRadio',
                questionTwoYesRadio: '#update-bank-questionTwoYesRadio',
                questionTwoNoRadio: '#update-bank-questionTwoNoRadio',
            },
            label: {
                questionOneLabel: '#update-bank-questionOneLabel',
                questionTwoLabel: '#update-bank-questionTwoLabel',
            },
            session: {
                errorBanner :'#update-bank-error-notification'
            }
        },
        urls: {
            UpdateBankSession: '/api/sitecore/UpdatePremiumBankDetails/UpdateBankSession',
            directDebitPageUrl: '/my-account/security/direct-debit-guarantee',
            errorPageUrl: '/error/error-page',
            validateBankDetails: '/api/sitecore/ValidateBankDetails/ValidateBankDetails'
        },
        constants: {
            ErrorMessageCode: 'Errors',
            InValidMessageCode: 'Invalid',
            ValidMessageCode: 'Valid',
            InValidAccountName: 'InvalidAccountName',
            SuccessMessageCode: '1',
            InValidAccountNumber: '-2',
            InValidSortNumber: '-1',
            SortCodeLength: 6,
            AccountNumberLength: 8,
            CharCodeUnitSeparator: 31,
            CharCodeNumericLowerBound : 48,
            CharCodeNumericUpperBound: 57,
            AccountNameLength: 18,
            AllowedAccountNameRegex: '[^a-zA-Z0-9 .\\-/&]',
            NumbersOnly:'[^0-9]',
            Forty: 40,
            FourHundred: 400
        },
        css: {
            invalidFormInput: 'vds-form__input--invalid',
            hide :'vds-hide'
        },
        checkBoxProperty: {
            checked: ':checked',
            disabled: 'disabled'
        },
        func: {
            init: function () {
                self.func.bindings();
                $(self.elements.messages.invalidAccountNumber).hide();
                $(self.elements.messages.invalidSortNumber).hide();
                $(self.elements.textBox.bankAccountNumber).removeClass(self.css.invalidFormInput);
                $(self.elements.textBox.bankSortNumber).removeClass(self.css.invalidFormInput);
            },
            bindings: function () {
                $(self.elements.UpdateForm).on('submit', self.func.handleSaveBankDetails);
                $(self.elements.textBox.bankSortNumber + ',' + self.elements.textBox.bankAccountNumber).on('keypress', self.func.allowOnlyNumbers);
                $(self.elements.textBox.bankSortNumber + ',' + self.elements.textBox.bankAccountNumber).on('paste', self.func.allowPastingOfNumbers);
                $(self.elements.textBox.bankAccountNumber).on('change', self.func.clearAccountNumberValidation);
                $(self.elements.textBox.bankSortNumber).on('change', self.func.clearSortNumberValidation);
                $(self.elements.textBox.bankAccountName).on('keypress', self.func.validateAccountName);
                $(self.elements.textBox.bankAccountName).on('paste', self.func.allowAccountNamePasting);
                $(self.elements.textBox.bankAccountName).on('invalid', self.func.inValidAccountNameMessage);
                $(self.elements.textBox.bankAccountName).on('input', self.func.onInputAccountName);
                $(self.elements.radio.questionOneYesRadio + ',' + self.elements.radio.questionOneNoRadio +
                  ',' + self.elements.radio.questionTwoYesRadio + ',' + self.elements.radio.questionTwoNoRadio)
                  .on('change', self.func.handleRadioChange);
            },
            handleRadioChange: function () {
                // Hide empty error messages when any radio is clicked
                self.func.hideElement(self.elements.messages.questionOneEmptyErrorMessage);
                self.func.hideElement(self.elements.messages.questionTwoEmptyErrorMessage);
                // Use helper to update error messages and get checked state
                const q1 = self.func.getRadioState(
                    self.elements.radio.questionOneYesRadio,
                    self.elements.radio.questionOneNoRadio,
                    self.elements.messages.questionOneErrorMessage
                );
                const q2 = self.func.getRadioState(
                    self.elements.radio.questionTwoYesRadio,
                    self.elements.radio.questionTwoNoRadio,
                    self.elements.messages.questionTwoErrorMessage
                );
                // If any "No" is selected, show error banner and disable save button
                if (q1.noChecked || q2.noChecked) {
                    self.func.showElement(self.elements.session.errorBanner);
                    $(self.elements.button.saveDetails).prop(self.checkBoxProperty.disabled, true);
                } else {
                    self.func.hideElement(self.elements.session.errorBanner);
                    $(self.elements.button.saveDetails).prop(self.checkBoxProperty.disabled, false);
                }
            },
            validateRadioQuestions: function () {
                let hasError = false;
                let scrollTarget = null;
                // Use helper to get checked state
                const q1 = self.func.getRadioState(
                    self.elements.radio.questionOneYesRadio,
                    self.elements.radio.questionOneNoRadio,
                    self.elements.messages.questionOneErrorMessage
                );
                const q2 = self.func.getRadioState(
                    self.elements.radio.questionTwoYesRadio,
                    self.elements.radio.questionTwoNoRadio,
                    self.elements.messages.questionTwoErrorMessage
                );
                // Question one empty check
                if (!q1.yesChecked && !q1.noChecked) {
                    self.func.showElement(self.elements.messages.questionOneEmptyErrorMessage);
                    scrollTarget = $(self.elements.label.questionOneLabel).first();
                    hasError = true;
                } else {
                    self.func.hideElement(self.elements.messages.questionOneEmptyErrorMessage);
                }
                // Question two empty check
                if (!q2.yesChecked && !q2.noChecked) {
                    self.func.showElement(self.elements.messages.questionTwoEmptyErrorMessage);
                    if (!scrollTarget) {
                        scrollTarget = $(self.elements.label.questionTwoLabel).first();
                    }
                    hasError = true;
                } else {
                    self.func.hideElement(self.elements.messages.questionTwoEmptyErrorMessage);
                }
                return { hasError, scrollTarget };
            },
            // Helper function to get radio state and show/hide error message
            getRadioState: function (yesSelector, noSelector, errorMessageSelector) {
                const yesChecked = $(yesSelector).is(self.checkBoxProperty.checked);
                const noChecked = $(noSelector).is(self.checkBoxProperty.checked);
                if (noChecked) {
                    self.func.showElement(errorMessageSelector);
                } else {
                    self.func.hideElement(errorMessageSelector);
                }
                return { yesChecked, noChecked };
            },
            hideElement: function (element) {
                $(element).addClass(self.css.hide);
            },
            showElement: function (element) {
                $(element).removeClass(self.css.hide);
            },
            clearAccountNumberValidation: function () {
                $(self.elements.messages.invalidAccountNumber).hide();
                $(self.elements.textBox.bankAccountNumber).removeClass(self.css.invalidFormInput);
            },
            clearSortNumberValidation: function () {
                $(self.elements.messages.invalidSortNumber).hide();
                $(self.elements.textBox.bankSortNumber).removeClass(self.css.invalidFormInput);
            },
            handleSaveBankDetails: function (event) {
                event.preventDefault();
                const { hasError, scrollTarget } = self.func.validateRadioQuestions();
                // If any question is unanswered, scroll to the first relevant radio label and do not proceed
                if (hasError && scrollTarget && scrollTarget.length) {
                    $('html, body').animate({
                        scrollTop: scrollTarget.offset().top - self.constants.Forty
                    }, self.constants.FourHundred);
                    return;
                }
                $(self.elements.messages.invalidAccountNumber).hide();
                $(self.elements.messages.invalidSortNumber).hide();
                $(self.elements.textBox.bankAccountNumber).removeClass(self.css.invalidFormInput);
                $(self.elements.textBox.bankSortNumber).removeClass(self.css.invalidFormInput);
                const sortNumber = $(self.elements.textBox.bankSortNumber).val();
                const accountNumber = $(self.elements.textBox.bankAccountNumber).val();
                if (sortNumber.length === self.constants.SortCodeLength && accountNumber.length === self.constants.AccountNumberLength) {
                    // AJAX call to validate premium bank details.
                    $.ajax({
                        type: 'POST',
                        url: self.urls.validateBankDetails,
                        data: { sortCode: sortNumber, accountNumber: accountNumber },
                        success: self.func.validateBankDetailsSuccess,
                        error: self.func.validateDetailsError
                    });
                }

            },
            validateBankDetailsSuccess: function (data) {
                const accountName = $(self.elements.textBox.bankAccountName).val().trim();
                const sortNumber = $(self.elements.textBox.bankSortNumber).val();
                const accountNumber = $(self.elements.textBox.bankAccountNumber).val();
                if (data.messageCode === self.constants.SuccessMessageCode && accountName !== '') {
                    // AJAX call to update the session
                    $.post(self.urls.UpdateBankSession, {
                        accountName: accountName, sortNumber: sortNumber, accountNumber: accountNumber
                    })
                        .done(function () {
                            window.location.href = self.urls.directDebitPageUrl;
                        })
                        .fail(function () {
                            window.location.href = self.urls.errorPageUrl;
                        });
                }
                if (data.messageCode === self.constants.InValidAccountNumber) {
                    $(self.elements.messages.invalidAccountNumber).show();
                    $(self.elements.textBox.bankAccountNumber).addClass(self.css.invalidFormInput);
                }
                if (data.messageCode === self.constants.InValidSortNumber) {
                    $(self.elements.messages.invalidSortNumber).show();
                    $(self.elements.textBox.bankSortNumber).addClass(self.css.invalidFormInput);
                }
            },
            validateDetailsError: function () {
                window.location.href = self.urls.errorPageUrl;
            },
            allowOnlyNumbers: function (event) {
                let isControlCode = (event.charCode <= self.constants.CharCodeUnitSeparator);
                let isDecimalCode = (event.charCode >= self.constants.CharCodeNumericLowerBound &&
                    event.charCode <= self.constants.CharCodeNumericUpperBound);
                if (!isControlCode && !isDecimalCode) {
                    event.preventDefault();
                    return false;
                }
            },
            allowPastingOfNumbers: function (event) {
                event.preventDefault();
                let clipData = event.originalEvent.clipboardData.getData('text');
                if (clipData) {
                    let regex = new RegExp(self.constants.NumbersOnly, 'g');
                    event.target.value = clipData.replace(regex, '');
                }
            },
            validateAccountName: function (event) {
                let regex = new RegExp(self.constants.AllowedAccountNameRegex);
                if (self.func.getPhcDirectDebitFlag()) {
                    const char = event.key;
                    if (regex.test(char)) {
                        event.preventDefault();
                    }
                }
            },
            allowAccountNamePasting: function (event) {
                if (self.func.getPhcDirectDebitFlag()) {
                    event.preventDefault();
                    const pastedData = event.originalEvent.clipboardData.getData('text');
                    if (pastedData) {
                        let regex = new RegExp(self.constants.AllowedAccountNameRegex, 'g');
                        event.target.value = pastedData.replace(regex, '').slice(0, self.constants.AccountNameLength);
                    }
                }
            },
            inValidAccountNameMessage: function () {
                let message = $(self.elements.textBox.hiddenAccountNameErrorMessage).val();
                this.setCustomValidity(message);
            },
            onInputAccountName: function () {
                this.setCustomValidity('');
            },
            getPhcDirectDebitFlag: function () {
                return $(self.elements.textBox.hiddenEnablePhcDirectDebit).val();
            }
        }
};

return {
    Init: self.func.init
};
}) ();

$(document).ready(function () {
    if ('update-bank-form' === $('#update-bank-form').data('feature')) {
        window.UpdatePremiumBankForm.Init();
    }
});
